export default {
  title: {
    en: 'You\'ve successfully unsubscribed',
  },
  text: {
    en: 'Thanks for being with us! Your reviews, scent queue and history will be available if and when you come back!',
  },
  comments: {
    en: 'If you were the CEO of Scentbird, what would you change to make your experience better?',
  },
  submitButton: {
    en: 'Submit my answer',
  },
}
